import { createStore, applyMiddleware, compose } from "redux";
import { loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n';
import { apiMiddleware } from "redux-api-middleware";
import thunk from "redux-thunk";
import { createBrowserHistory } from "history";

import { rootReducer } from "./reducers";
import translationsObject from '../internationalisation/data.json';

const initialState = {};
const enhancers = [];
const middleware = [apiMiddleware, thunk];

export const history = createBrowserHistory();

if (process.env.NODE_ENV === "development" && typeof window != "undefined") {
  const devToolsExtension = window.devToolsExtension;

  if (typeof devToolsExtension === "function") {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

export const store = createStore(rootReducer, initialState, composedEnhancers);

syncTranslationWithStore(store)
store.dispatch(loadTranslations(translationsObject));
store.dispatch(setLocale('en'));

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
